import React from "react";
import { toElementProps } from "../../Element";

export function BlockGridRowStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-grid-row": {
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            gridGap: "16px",

            height: "100%",

            [MobileBreakpoint]: {
                display: "flex !important",
                flexDirection: "column",

                "& .image img": {
                    width: "unset",
                },
            },
        },
    };
}

export default function BlockGridRow(props) {
    if (!props.children || props.children.length === 0) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["block-grid-row"] });
    return <div {...elProps}>{props.children}</div>;
}
